module.exports = __webpack_public_path__ + "static/media/throwball_team.0c3feb62.jpeg";